<template>
  <v-snackbar v-model="Snackbar.mostrar" :color="Snackbar.color" :timeout="timeout" bottom>
    {{ Snackbar.texto }}
    <v-btn dark text @click="ocultar">Cerrar</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      timeout: 3000
    };
  },
  computed: {
    ...mapState("comun", ["Snackbar"])
  },
  methods: {
    ...mapMutations("comun", ["ocultar"])
  }
};
</script>

<style>
</style>